import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-textHidden",
  "use": "icon-textHidden-usage",
  "viewBox": "0 0 26 26",
  "content": "<symbol viewBox=\"0 0 26 26\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-textHidden\">\r\n<path d=\"M11.6585 17.8123H13.7192V9.56949H17.8406V7.50879H7.53711V9.56949H11.6585V17.8123Z\" fill=\"currentColor\" />\r\n<path d=\"M24.8418 1L0.773438 25.0679\" stroke=\"currentColor\" />\r\n<rect x=\"3.40039\" y=\"3.37256\" width=\"18.5767\" height=\"18.5767\" stroke=\"currentColor\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol